export const APP_VERSION = '4.50.0';
